// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"404":"4f034e44","420":"cf687632"}[chunkId] + ".css";
};